import { createContext, useContext, useState, useEffect } from 'react';

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    try {
      const saved = localStorage.getItem('favorites');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('favorites', JSON.stringify(favorites));
  }, [favorites]);

  const addFavorite = (business) => {
    setFavorites(prev => {
      if (prev.some(b => b.id === business.id)) return prev;
      return [...prev, {
        id: business.id,
        name: business.name,
        category: business.category,
        city: business.city,
        addedAt: new Date().toISOString()
      }];
    });
  };

  const removeFavorite = (businessId) => {
    setFavorites(prev => prev.filter(b => b.id !== businessId));
  };

  const isFavorite = (businessId) => {
    return favorites.some(b => b.id === businessId);
  };

  const toggleFavorite = (business) => {
    if (isFavorite(business.id)) {
      removeFavorite(business.id);
    } else {
      addFavorite(business);
    }
  };

  return (
    <FavoritesContext.Provider value={{ 
      favorites, 
      addFavorite, 
      removeFavorite, 
      isFavorite, 
      toggleFavorite,
      favoritesCount: favorites.length 
    }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavorites must be used within a FavoritesProvider');
  }
  return context;
};
